import { DisplayWarnings } from '../DisplayWarnings';
import { validateProgramData } from '../services/program-utils';
import { getProgramName } from '../utils';
import { showProgramSummary } from '../summary/ProgramSummary';
import { PageNotFound } from '@/app/core/components/PageNotFound';
import {
  ProgramWizard,
  ProgramWizardContainer,
} from '@/app/core/components/program-wizard';
import { getCurrentFeatureCode } from '@/app/core/auth';
import { canAccessQuestProduct } from '@/app/core/utils';
import { Switch, Route, useHistory } from 'react-router-dom';
import {
  PackageNameEnum,
  ProductNameEnum,
  SSARProgram,
} from '@ssar-app/domain';
import { usePathContext } from '@ssar-app/okta-authn-react';
import { HStack, Link, Text, VStack } from '@chakra-ui/react';
import { Modal } from '@ssar-app/uikit';

export const CreateProgram = () => {
  const { buildPath } = usePathContext();
  const featureCode = getCurrentFeatureCode();
  const history = useHistory();

  const displayRedirectPopup = () => {
    const modal = Modal.info({
      header: 'Information',
      closable: true,
      closeOnOverlayClick: false,
      showOk: true,
      okText: 'Close',
      contentProps: { maxW: '2xl' },
      onClose: () => {
        history.push(buildPath(`/dashboard?show=jobs`));
        modal.destroy();
      },
      content: (
        <VStack alignItems='baseline' whiteSpace={'nowrap'}>
          <Text>
            Starting October 10, 2025 you are unable to create or submit a new
            file here.
          </Text>
          <HStack whiteSpace={'nowrap'}>
            <Text>
              Please go to
              <Link
                href='https://ascend.experian.com/access/login'
                isExternal
                color='blue.500'
                m={1}
              >
                the new Ascend Quest site
              </Link>
              to submit your account review programs.
            </Text>
          </HStack>
        </VStack>
      ),
      scrollBehavior: 'outside',
      bodyProps: { pb: 6 },
    });
  };

  return (
    <>
      {!canAccessQuestProduct('2025-10-11') && displayRedirectPopup()}
      {(featureCode !== ProductNameEnum.AscendQuest ||
        canAccessQuestProduct('2025-10-11')) && (
        <Switch>
          <Route path={buildPath('/program/create')}>
            <ProgramWizardContainer
              productName={featureCode as ProductNameEnum}
              packageName={PackageNameEnum.WebQuest}
              header={<ProgramWizard.Header></ProgramWizard.Header>}
              footer={<ProgramWizard.Footer></ProgramWizard.Footer>}
              warnings={(messages) => {
                return <DisplayWarnings messages={messages} />;
              }}
              validations={{
                preSubmit: validateProgramData,
              }}
              handlers={{
                programNameExtractor: (model) =>
                  getProgramName(model as SSARProgram),
                summaryHandler: (model, ...rest) =>
                  showProgramSummary(model as SSARProgram, ...rest),
              }}
            >
              {(stepWizardProps, _dataStoreState) => {
                return <>{stepWizardProps.steps}</>;
              }}
            </ProgramWizardContainer>
          </Route>
          <Route path='*'>
            <PageNotFound />
          </Route>
        </Switch>
      )}
    </>
  );
};
